import Popover from '@stimulus-components/popover'

// Connects to data-controller="popover"
export default class extends Popover {
  show(event) {
    if (this.hasCardTarget) return

    super.show(event)
    this.open()
  }

  hide(event) {
    super.hide(event)
    this.close()
  }

  open() {
    this.element.dataset.state = 'open'
    const trigger = this.triggerElement
    if (trigger) trigger.setAttribute('aria-expanded', 'true')
  }

  close() {
    this.element.dataset.state = 'closed'
    const trigger = this.triggerElement
    if (trigger) trigger.setAttribute('aria-expanded', 'false')
  }

  get triggerElement() {
    return this.element.querySelector('[aria-haspopup="true"]')
  }

  preventClick(event) {
    event.preventDefault()
  }
}
